import { createContext, Dispatch, SetStateAction } from "react"

export interface RootThemeContextProps {
  setBlockScroll: Dispatch<SetStateAction<boolean>>
}

export const RootThemeContext = createContext<RootThemeContextProps>({
  setBlockScroll: () => {},
})
